<app-modal>
  <app-loading *ngIf="loading"></app-loading>
  <ng-container *ngIf="!loading">
    <app-modal-header
      [showDelete]="false"
      [title]="T.common.add_item | translate: { item: 'Indicator' }"
      (closed)="closeModal()">
    </app-modal-header>

    <app-modal-body>
      <div [formGroup]="indicatorForm">
        <section class="row col-row-space custom-gutters section-padding">
          <div class="col-12">
            <app-text-field
              [formGroup]="indicatorForm"
              formControlName="title"
              [placeholder]="(T.defaultLocalizations.title.one | translate) + '*'"
              [displayError]="triggerIndicatorErrors"
              [useReactiveMessages]="true"
              [required]="true"
            ></app-text-field>
          </div>
          <div class="col-12">
            <app-filter-dropdown-new
              [filterType]="filterTypes.Indicator_Category"
              [appliedFilters]="indicator.filters"
              [disableMargin]="true"
              [typeahead]="true"
              [label]="(T.common.category.one | translate) + '*'"
              [displayError]="triggerIndicatorErrors"
              [required]="true"
              (onFilterUpdate)="updateIndicatorCategory($event)"
              [singleSelect]="true">
            </app-filter-dropdown-new>
          </div>
          <div class="col-12">
            <app-details-editable-field
              [input]="indicator.description ? indicator.description : ''"
              [minLength]="0"
              [type]="editableFieldTypes.RichText"
              [header]="T.defaultLocalizations.description.one | translate"
              [placeholder]="T.common.add_description | translate"
              [canEdit]="true"
              (onUpdate)="onDescriptionChange($event)"
              (isInvalid)="isDescriptionInvalid($event)">
            </app-details-editable-field>
          </div>
        </section>

        <app-accordion-details [collapsing]="false" [emphasizedHeaders]="true">
          <app-accordion-item-details [title]="T.sustainability.indicator_type | translate" [expanded]="false">
            <ng-template accordionContent>
              <section class="row col-row-space custom-gutters section-padding">
                <div class="col-12 d-flex">
                  <app-radio-button
                    class="me-4"
                    [checked]="indicator.updateType === indicatorUpdateTypes.Numeric || !indicator.updateType"
                    [text]="T.sustainability.numeral_tracking | translate"
                    (checkedChanged)="updateIndicatorUpdateType(indicatorUpdateTypes.Numeric)">
                  </app-radio-button>
                  <app-radio-button
                    [checked]="indicator.updateType === indicatorUpdateTypes.Pass_Or_Fail"
                    [text]="T.sustainability.pass_and_fail_tracking | translate"
                    (checkedChanged)="updateIndicatorUpdateType(indicatorUpdateTypes.Pass_Or_Fail)">
                  </app-radio-button>
                </div>
                <ng-container *ngIf="indicator.updateType === indicatorUpdateTypes.Numeric">
                  <div class="col-12">
                    <app-filter-dropdown-new
                      [filterType]="filterTypes.Expected_Direction"
                      [appliedFilters]="expectedDirectionFilters"
                      [disableMargin]="true"
                      [typeahead]="true"
                      [label]="(T.sustainability.expected_direction.one | translate) + '*'"
                      [displayError]="triggerIndicatorErrors"
                      [required]="true"
                      [currentlySelectedSettingValue]="expectedDirectionSelectedFilter?.filterValue"
                      (onFilterUpdate)="updatedExpectedDirection($event)"
                      [singleSelect]="true">
                    </app-filter-dropdown-new>
                  </div>
                  <div class="col-12">
                    <app-filter-dropdown-new
                      [filterType]="filterTypes.Unit_Type"
                      [appliedFilters]="[unitTypeSelectedFilter]"
                      [disableMargin]="true"
                      [typeahead]="true"
                      [label]="(T.settings.sustainability.unit_measurements.unit_Type_label | translate) + '*'"
                      [displayError]="triggerIndicatorErrors"
                      [required]="true"
                      [currentlySelectedSettingValue]="unitTypeSelectedFilter?.filterValue"
                      (onFilterUpdate)="updateIndicatorUnitType($event)"
                      [singleSelect]="true"
                      [excludeFilterValues]="excludedUnitTypeIds">
                    </app-filter-dropdown-new>
                    <div class="bottom-element d-flex mt-2 ms-2">
                      <app-button-transparent
                        [app-tooltip]="{ message: T.sustainability.add_indicator_unit_type_helper_text | translate }"
                        size="small"
                        [text]="T.common.learn_more | translate">
                      </app-button-transparent>
                    </div>
                  </div>
                  <div class="col-12">
                    <app-filter-dropdown-new
                      [filterType]="filterTypes.Unit"
                      [usePredefinedFilters]="true"
                      [predefinedFilters]="unitFilters"
                      [appliedFilters]="[unitSelectedFilter]"
                      [disableMargin]="true"
                      [typeahead]="true"
                      [label]="T.settings.sustainability.unit_measurements.unit_label | translate"
                      [currentlySelectedSettingValue]="unitSelectedFilter?.filterValue"
                      (onFilterUpdate)="updateIndicatorUnit($event)"
                      [singleSelect]="true">
                    </app-filter-dropdown-new>
                    <div class="bottom-element d-flex mt-2 ms-2">
                      <app-button-transparent
                        [app-tooltip]="{ message: T.sustainability.add_indicator_unit_helper_text | translate }"
                        size="small"
                        [text]="T.common.learn_more | translate">
                      </app-button-transparent>
                    </div>
                  </div>
                  <div class="col-12">
                    <app-filter-dropdown-new
                      [filterType]="filterTypes.Unit"
                      [usePredefinedFilters]="true"
                      [predefinedFilters]="unitFilters"
                      [appliedFilters]="[convertionSelectedUnitFilter]"
                      [disableMargin]="true"
                      [typeahead]="true"
                      [label]="T.settings.sustainability.unit_measurements.unit_conversion_label | translate"
                      [displayError]="triggerIndicatorErrors"
                      [required]="true"
                      [currentlySelectedSettingValue]="convertionSelectedUnitFilter?.filterValue"
                      (onFilterUpdate)="updateConversionIndicatorUnit($event)"
                      [singleSelect]="true"
                      [disabled]="isConversionDisabled">
                    </app-filter-dropdown-new>
                    <div class="bottom-element d-flex mt-2 ms-2">
                      <app-button-transparent
                        [app-tooltip]="{ message: T.sustainability.add_indicator_convert_value_to_helper_text | translate }"
                        size="small"
                        [text]="T.common.learn_more | translate">
                      </app-button-transparent>
                    </div>
                  </div>
                  <ng-container *ngIf="useCarbonEmissions">
                    <div>
                      <div class="col-12 mb-1 carbon-emissions-title">{{  T.sustainability.track_carbon_emissions | translate }}</div>
                      <div class="col-12 mb-4 carbon-emissions-sub-title">{{ T.sustainability.set_emissions_factors_sub_title | translate }}</div>
                      <app-checkbox-with-label
                        [fontWeight]="600"
                        [label]="T.sustainability.track_carbon_emissions | translate"
                        [intialState]="trackCarbonEmissions ? 'checked' : 'unchecked'"
                        (clicked)="onCarbonEmissionsTrackingChanged($event)">
                      </app-checkbox-with-label>
                      <div class="col-12 mt-4">
                        <div class="col-12 d-flex justify-content-between align-items-center">
                          <app-search-dropdown-r
                            class="w-50"
                            [label]="T.settings.sustainability.region | translate"
                            [objects]="climatiqRegions"
                            [currentlySelectedObject]="selectedClimatiqRegion"
                            [multiSelect]="false"
                            [currentlySelectedObject]=""
                            [disabled]="emissionsFactorIsLoading || !trackCarbonEmissions || !filteredClimaticIndicatorEmissionsData.length"
                            bindProperty="name"
                            (objectCleared)="onClimatiqRegionCleared()"
                            (objectSelected)="onClimatiqRegionChanged($event)">
                          </app-search-dropdown-r>
                          <app-search-dropdown-r
                            class="w-40"
                            [label]="T.settings.sustainability.source | translate"
                            [objects]="climatiqSources"
                            [currentlySelectedObject]="selectedClimatiqSource"
                            [multiSelect]="false"
                            [currentlySelectedObject]=""
                            bindProperty="title"
                            [disabled]="emissionsFactorIsLoading || !trackCarbonEmissions || !filteredClimaticIndicatorEmissionsData.length"
                            (objectCleared)="onClimatiqSourceCleared()"
                            (objectSelected)="onClimatiqSourceChanged($event)">
                          </app-search-dropdown-r>
                        </div>
                        <div>
                          <div class="col-12 mt-4 emission-factors">{{ T.sustainability.emissions_factors | translate }}</div>
                          <div class="search-result-description mb-2">
                            <div class="description">
                              {{ T.sustainability.choose_factors | translate }}:
                            </div>
                          </div>
                          <ng-container *ngIf="emissionsFactorIsLoading">
                            <app-loading></app-loading>
                          </ng-container>
                          <ng-container *ngIf="!emissionsFactorIsLoading">
                            <div class="search-container">
                              <app-text-field
                                [placeholder]="T.sustainability.enter_emissions_keyword | translate"
                                [maxLength]="250"
                                [disabled]="!filteredClimaticIndicatorEmissionsData.length"
                                [required]="false"
                                [autofocus]="true"
                                [disableMargin]="true"
                                [icon]="'search'"
                                name="Keyword"
                                (onChange)="emissionFactorSearchSubject.next($event)">
                              </app-text-field>
                            </div>
                            <ng-container *ngIf="filteredClimaticIndicatorEmissionsData?.length; else noEmissionsFactorFound">
                              <div class="search-result-list custom-scrollbar">
                                <div class="search-result-item" *ngFor="let e of filteredClimaticIndicatorEmissionsData">
                                  <div class="radio-btn">
                                    <app-radio-button
                                      [name]="'emissionFactor'"
                                      [checked]="indicator.estimateParameter?.activity_id === e.activity_id && indicator.estimateParameter?.region === e.region"
                                      text=""
                                      (checkedChanged)="onEmissionFactorSelected(e)"
                                    ></app-radio-button>
                                  </div>
                                  <div class="search-result-item-title">{{ e.name }}</div>
                                  <div class="search-result-item-source">{{ e.source }}</div>
                                  <div class="search-result-item-region">{{ e.region }}</div>
                                  <div class="search-result-item-source-link d-flex align-items-center">
                                    <a href="{{e.source_link}}" class="me-2" target="_new">{{ T.settings.sustainability.source | translate}}</a>
                                    <i class="material-symbols-outlined">open_in_new</i>
                                  </div>
                                </div>
                              </div>
                            </ng-container>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                </ng-container>
              </section>
            </ng-template>
          </app-accordion-item-details>
          <app-accordion-item-details [title]="T.sustainability.updates | translate">
            <ng-template accordionContent>
              <section class="row col-row-space custom-gutters section-padding">
                <div class="col-12 d-flex justify-content-space-between align-items-center">
                  <app-text-field
                    [placeholder]="''"
                    [displayError]="triggerIndicatorErrors"
                    [maxLength]="2"
                    [useReactiveMessages]="true"
                    [required]="true"
                    [disableMargin]="true"
                    formControlName="trackingDateValue"
                    [formGroup]="indicatorForm">
                  </app-text-field>
                  <div class="ms-4 me-4">X</div>
                  <app-filter-dropdown-new
                    [filterType]="filterTypes.Indicator_Tracking_Date_Type"
                    [appliedFilters]="indicator.filters"
                    [disableMargin]="true"
                    [typeahead]="true"
                    [label]="(T.sustainability.frequency | translate) + '*'"
                    (onFilterUpdate)="updateTrackingDateType($event)"
                    [singleSelect]="true">
                  </app-filter-dropdown-new>
                </div>
                <div class="col-12 d-flex justify-content-space-between align-items-center">
                  <app-datepicker
                    [date]="indicatorStartDate"
                    [minDate]="today"
                    (dateChanged)="updateStartDate($event)"
                    [placeholder]="T.sustainability.start_tracking | translate"
                    [showPlaceholderFirst]="true"
                    [disableMargin]="true">
                  </app-datepicker>
                  <div class="ms-4 me-4">-</div>
                  <app-datepicker
                    [date]="indicatorDueDate"
                    [minDate]="indicatorStartDate"
                    (dateChanged)="updateDueDate($event)"
                    [placeholder]="T.sustainability.end_tracking | translate"
                    [showPlaceholderFirst]="true"
                    [disableMargin]="true">
                  </app-datepicker>
                </div>
              </section>
            </ng-template>
          </app-accordion-item-details>
          <app-accordion-item-details [title]="T.common.details | translate">
            <ng-template accordionContent>
              <section class="row col-row-space custom-gutters section-padding">
                <div class="col-12">
                  <app-filter-dropdown-new
                    style="width: 100%"
                    [filterType]="filterTypes.GHG_Reporting_Category"
                    [appliedFilters]="indicator.filters"
                    [disableMargin]="true"
                    [typeahead]="true"
                    [label]="(T.sustainability.ghg_category | translate)"
                    [displayError]="triggerIndicatorErrors"
                    [required]="false"
                    (onFilterUpdate)="updateGHGReportingCategory($event)"
                    [singleSelect]="true">
                  </app-filter-dropdown-new>
                </div>
                <div class="col-12">
                  <app-filter-dropdown-new
                    style="width: 100%"
                    [filterType]="filterTypes.Pillar"
                    [appliedFilters]="indicator.filters"
                    [disableMargin]="true"
                    [typeahead]="true"
                    [label]="(T.sustainability.pillar | translate)"
                    [displayError]="triggerIndicatorErrors"
                    [required]="false"
                    (onFilterUpdate)="updatePillar($event)"
                    [singleSelect]="true">
                  </app-filter-dropdown-new>
                </div>
                <div class="col-12">
                  <app-filter-dropdown-new
                    [filterType]="filterTypes.Reporting_Directive"
                    [appliedFilters]="indicator.filters"
                    [disableMargin]="true"
                    [typeahead]="true"
                    [label]="T.sustainability.reporting_directive | translate"
                    (onFilterUpdate)="updateViewModel($event)">
                  </app-filter-dropdown-new>
                </div>
                <div class="col-12">
                  <app-filter-dropdown-new
                    [filterType]="filterTypes.Sustainability_Scope"
                    [appliedFilters]="indicator.filters"
                    [disableMargin]="true"
                    [typeahead]="true"
                    [label]="T.settings.sustainability.scope | translate"
                    [displayError]="triggerIndicatorErrors"
                    [required]="true"
                    (onFilterUpdate)="updateIndicatorScope($event)"
                    [singleSelect]="true">
                  </app-filter-dropdown-new>
                </div>
                <div class="col-12">
                  <app-filter-dropdown-new
                    [displayError]="triggerIndicatorErrors"
                    [filterType]="filterTypes.UNSDG"
                    [appliedFilters]="indicator.filters"
                    [typeahead]="true"
                    [disableMargin]="true"
                    [label]="T.sustainability.un_sustainability_goals | translate"
                    (onFilterUpdate)="updateViewModel($event)">
                  </app-filter-dropdown-new>
                  <div class="bottom-element d-flex mt-2 ms-2">
                    <app-button-transparent
                      [app-tooltip]="{ message: T.sustainability.unsdg_helper_text | translate }"
                      size="small"
                      [text]="T.common.learn_more | translate">
                    </app-button-transparent>
                  </div>
                  <div class="col-12">
                    <app-filter-dropdown-new
                      [displayError]="triggerIndicatorErrors"
                      [filterType]="filterTypes.Indicator_Priority"
                      [appliedFilters]="indicator.filters"
                      [typeahead]="true"
                      [disableMargin]="true"
                      [singleSelect]="true"
                      [label]="T.defaultLocalizations.priority.one | translate"
                      (onFilterUpdate)="onApply($event)">
                    </app-filter-dropdown-new>
                  </div>
                </div>
              </section>
            </ng-template>
          </app-accordion-item-details>
          <app-accordion-item-details [title]="T.defaultLocalizations.assign_and_tag | translate">
            <ng-template accordionContent>
              <section class="row col-row-space custom-gutters section-padding">
                <div class="col-12">
                  <app-filter-dropdown-new
                    [filterType]="filterTypes.Owner"
                    [appliedFilters]="indicator.filters"
                    [disableMargin]="true"
                    [typeahead]="true"
                    [label]="T.common.assign_owner.many | translate"
                    (onFilterUpdate)="updateViewModel($event)">
                  </app-filter-dropdown-new>
                  <div class="bottom-element d-flex">
                    <app-button-transparent
                      size="small"
                      icon="add"
                      [text]="T.common.assign_me | translate"
                      (clicked)="addCurrentUserAsOwner()"
                    ></app-button-transparent>
                  </div>
                </div>
                <div class="col-12">
                  <app-filter-dropdown-new
                    [filterType]="filterTypes.Department"
                    [appliedFilters]="indicator.filters"
                    [disableMargin]="true"
                    [typeahead]="true"
                    [label]="T.common.assign_items | translate: { items: localisedDepartments }"
                    (onFilterUpdate)="updateViewModel($event)">
                  </app-filter-dropdown-new>
                  <div class="bottom-element d-flex">
                    <app-button-transparent
                      size="small"
                      icon="add"
                      [text]="T.common.assign_my_localisedDepartment | translate: { localisedDepartment: localisedDepartment }"
                      (clicked)="addCurrentUserDepartment()">
                    </app-button-transparent>
                  </div>
                </div>
                <div class="col-12">
                  <app-filter-dropdown-new
                    [filterType]="filterTypes.Department_Category"
                    [appliedFilters]="indicator.filters"
                    [disableMargin]="true"
                    [typeahead]="true"
                    [label]="T.common.assign_items | translate: { items: localisedDepartmentCategories }"
                    (onFilterUpdate)="updateViewModel($event)">
                  </app-filter-dropdown-new>
                </div>
                <div class="col-12">
                  <app-add-modal-tag-groups
                    [filters]="indicator.filters"
                    [layoutClasses]="'col-12'"
                    [tagGroupObjectType]="objectTypes.Indicator"
                    (onFiltersUpdated)="updateViewModel($event)">
                  </app-add-modal-tag-groups>
                </div>
              </section>
            </ng-template>
          </app-accordion-item-details>
        </app-accordion-details>
      </div>
    </app-modal-body>

    <app-modal-footer>
      <app-button-rectangle
        [buttonTheme]="'white'"
        [size]="'large'"
        [text]="T.common.cancel | translate"
        (clicked)="cancel()"
      ></app-button-rectangle>
      <app-button-rectangle
        [disabled]="isIndicatorValid()"
        [size]="'large'"
        [text]="T.common.save | translate"
        (clicked)="onSave()"
      ></app-button-rectangle>
    </app-modal-footer>
  </ng-container>
</app-modal>

<ng-template #noEmissionsFactorFound>
  <div class="no-emissions-factor-found">
    <div class="no-emissions-factor-found-description">
      {{ T.sustainability.no_options_found | translate }}
    </div>
  </div>
</ng-template>
